export const getUserName = (userName?: string, isSubUserSend?: boolean) => {
  if (!userName) return 'Unknown';

  if (userName && isSubUserSend) return `対話者`;

  return userName;
};
